module.exports = __webpack_public_path__ + "img/AppSensorsScreen2.1adfec07.png";